<dialog #dialog
        class="popin-dialog"
        aria-modal="true">
    <div class="mx-4">
        <div class="text-center">

            <logo-marianne class="text-start" [isInPopIn]="true">Ministère<br>de la Justice</logo-marianne>

            <p class="c-text c-text-home c-text-home-bold mt-3">{{ messagePopIn }}</p>

            <div class="mt-4 d-inline-flex flex-column flex-sm-row gap-3 justify-content-center">
                <button type="button" class="btn c-btn c-btn-ocean"
                        translate="global.form.button.yes"
                        (click)="reponseOuiQuestionPopIn()"></button>
                <button type="button" class="btn c-btn c-btn-ocean"
                        translate="global.form.button.no"
                        (click)="reponseNonQuestionPopIn()"></button>
            </div>
        </div>
    </div>
</dialog>
